import React, { useEffect } from "react";
import { setSubTitle } from "../stores/AppReducer";
import { useDispatch } from "react-redux";
import type { AppDispatch } from "../stores/AppStore";

const signatur = [
    ":77:97:116:116:104:105:97:115:32:82:117:100:111:108:112:104",
    ":49:56:53:49:48:32:97:110:32:100:101:114:32:75:252:115:116:101",
    ":112:111:115:116:64:109:105:99:114:111:102:105:120:46:100:101",
];
const decrypt = (s: string) => {
    let S = "";
    s.split(":").forEach((c: string) => {
        const code = parseInt(c, 10);
        code === 33 ? S += "ü" : S += String.fromCharCode(code);
    });
    return S;
};

function Impressum() {
    const dispatch = useDispatch<AppDispatch>();
    useEffect(() => {
        dispatch(setSubTitle("Impressum"));
    }, []);
    const renderSignatur = (s: string, idx: number) => {
        return (
            <div key={"sig_" + idx}>{decrypt(s)}</div>
        );
    };
    return (
        <div className="home">
            <div className="impresstext">
                <p>
                    Microfix.de ist eine experimentelle Website. 
                    Zum Probieren und Studieren. Online seit 2003!
                </p>
                <p> <u>Der Autor:</u></p>
                {signatur.map(renderSignatur)}
                <p>
                    Der Name <i>Microfix</i> ist hier ein Wortspiel und lehnt sich an eine bekannte verfilmte Komikserie an,
                    in der es um ein kleines gallisches Dorf geht, deren Protagonisten Namen tragen,
                    die ausschließlich auf x enden und die stets einer großen Macht kritisch gegenüber stehen.
                    Jeder möge sich selbst einen Reim darauf machen, was hier gemeint sein könnte.  
                </p>
                <p>
                    Inzwischen (nach 20 Jahren) gibt es Domains, die ähnlich klingen.
                    Falls Sie vermuten, dass mit dieser Website direkt oder indirekt eines Ihrer Schutzrechte verletzt wird,
                    so teilen Sie dies bitte umgehend dem o.g. Autor per Email mit, damit zügig Abhilfe geschafft werden kann.
                    Bitte nehmen Sie zur Kenntnis, dass die zeitaufwendigere Einschaltung eines Anwaltes zur kostenpflichtigen Abmahnung
                    nicht dem wirklichen oder mutmaßlichen Willen des Autors entspricht.
                </p>
                <p>
                    Auch wenn diese Website Teil des Internets ist, ist deren Motivation weder Selbstdarstellung noch
                    Drang nach Publicity.
                    Dem Autor ist es vollkommen egal ob seine Website von diversen Suchmaschinen gefunden wird oder nicht.
                    Die, die davon profitieren sollen, werden direkt informiert bzw. erhalten einen entsprechenden Link.
                    Alle anderen mögen bitte entschuldigen, dass es hier nicht viel zu sehen gibt.
                </p>
            </div>
        </div>
    );
}

export default (Impressum);
